import { PARTY } from '../../types/party.js';
import { validateParty } from '../../validators/validateParty.js';
import { syncConnectorRegistry } from '../sync/syncConnectorRegistry.js';
/**
 * Party fields written by the legacy catalog sync (spec 0035 §D2).
 *
 * Origin owns these fields: the select overwrites on every sync that changes
 * the party — including `roles`. A select that omits a column leaves
 * `undefined` in the mapper → `pickOwnedFields` skips it → SysColect value is
 * preserved.
 *
 * Every key produced by {@link toParty} except `id` belongs here. Party has no
 * SysColect-only FKs analogous to product §C4.
 */
export const PARTY_SYNC_OWNED_FIELDS = [
    'code',
    'partyType',
    'displayName',
    'roles',
    'cpf',
    'birthDate',
    'cnpj',
    'tradeName',
    'legalName',
    'email',
    'phone',
    'addressZipCode',
    'addressStreet',
    'addressNumber',
    'addressComplement',
    'addressDistrict',
    'addressState',
    'addressCity',
    'addressCityId',
    'addressStateId',
    'notes',
    'inclusionDate',
    'active',
    'inactivationDate',
];
export const partySyncConnector = {
    key: 'vh:data-party',
    label: 'Clientes e fornecedores',
    entity: PARTY,
    ownedFields: PARTY_SYNC_OWNED_FIELDS,
    validate: validateParty,
    lifecycle: true,
    versioned: true,
    /**
     * Party is still read live from the ERP by RestScript in many orgs, so every
     * SysColect FK (`partyId` on invoices, NF-e promote, orders) already stores
     * COD_CLIFOR. A UUID localId would orphan those references.
     */
    localIdFromExternalId: true,
};
/** Registers the party connector (idempotent overwrite). */
export function registerPartySyncConnector() {
    syncConnectorRegistry.register(partySyncConnector);
}
//# sourceMappingURL=party.connector.js.map